import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FilterRangeOption} from "../interface/filter-range-option";

@Component({
  selector: 'fb-filter-range-control',
  templateUrl: './filter-range-control.component.html',
  styleUrls: ['./filter-range-control.component.scss']
})
export class FilterRangeControlComponent implements OnInit, AfterViewInit {

	@Input()
	public control: FilterRangeOption = {} as FilterRangeOption;
	@Output()
	public onControlChange: EventEmitter<null> = new EventEmitter<null>();
	public static waitTime: number = 1000;
	public timer: any;

	constructor(
		private _cd: ChangeDetectorRef
	) {
	}

	ngOnInit(): void {
	}

	public triggerInput(minSlideValue: number, maxSlideValue: number) {
		this.changeControlValue(minSlideValue, maxSlideValue);
		this.onControlChange.next(null);
	}

	public triggerSlider(minSlideValue: number, maxSlideValue: number) {
		this.changeControlValue(minSlideValue, maxSlideValue);
		clearTimeout(this.timer);
		this.timer = setTimeout(() => {
			this.onControlChange.next(null);
		}, FilterRangeControlComponent.waitTime)
	}

	public reset(): void {
		this.control.value1 = this.control.defaultMin;
		this.control.value2 = this.control.defaultMax;
		this.triggerInput(this.control.defaultMin, this.control.defaultMax);
	}

	ngAfterViewInit() {
		this._cd.detectChanges();
	}

	private changeControlValue(minSlideValue: number, maxSlideValue: number): void {
		this.control.value1 = minSlideValue;
		this.control.value2 = maxSlideValue;

		if (this.control.value1 || this.control.defaultMax === this.control.value2) {
			this.control.active = false;
		}
		if (this.control.defaultMin < this.control.value1 || this.control.defaultMax > this.control.value2) {
			 this.control.active = true;
		}
	}
}
